import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {RouteComponentProps, Link, useHistory} from 'react-router-dom';
import parse from 'html-react-parser';

import FooterComponent from "../component/footer/FooterComponent";
import HeaderLightComponent from "../component/header/HeaderLightComponent";

import Back from '../component/svg/Back';
import SelectForm from '../component/form/SelectForm';
import storage from '../util/storage';
import { EModule } from '../../domain/User/Emodule';
import PreSignatureValidationFoldersComponent from '../component/folder/PreSignatureValidationFoldersComponent';
import AppearanceDropdown, { ListAppearance } from '../component/button/AppearanceDropDown';
import { getFoldersDataViewMode } from '../util/envVariable';

interface Params {
  currentPage: string
}

const PreSignatureValidationFolder = ({match}: RouteComponentProps<Params>): JSX.Element => {
  const { t } = useTranslation()
  const history = useHistory()

  const [term, setTerm] = useState<string>('');
  const [selectedForm, setSelectedForm] = useState<string|null>(null)

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setTerm((e.target.value).toLowerCase());
  }

  const title = t('dashboard.pre-signature-validation')

  const userProfile = storage.getUserInformation()
  const previousPage = localStorage.getItem("previousPage") || "/tableau-de-bord";
  const [viewMode, setViewMode] = useState<ListAppearance>(getFoldersDataViewMode());

  if (!userProfile?.modules?.includes(EModule.PreSignatureValidator)) {
    window.location.pathname = '/'
  }
  const getListClassNames = () => {
    if ('table' === viewMode) {
      return 'box-elevations--anim box-elevations-xl box-elevations--base box-elevations--max-heigt-initial no-padding'
    }
    return 'box-elevations box-elevations-xl box-elevations--base box-elevations--max-heigt-initial box-elevations--mb u-mxAuto'
  }

  return (
    <div className="page-layout">
      <HeaderLightComponent />
      <main className="wrap u-mxXl u-pv-m">

        {/* 1. Zone Bouton Retour */}
        <div className="flex-container u-mb-s">
          <div className="col-md-12">
            <Link to="#" onClick={(event) => {
                event.preventDefault();
                history.push(previousPage)
              }}>
                <Back color="var(--ink-1)" />
                <span className="u-txt-size-s u-txt-color-ink-1 u-mxs">{t('button.back')}</span>
              </Link>
          </div>
        </div>

        {/* 2. En-tête de page (Titre + Filtres) */}
        <div className="flex-container align-middle u-mb-m">

          {/* Colonne Titre */}
          <div className="col-md-5 flex-container no-compensation-xs">
            <h2 className="h3 h3-center">{parse(title)}</h2>
            <AppearanceDropdown currentValue={viewMode} onSelect={setViewMode}/>
          </div>

          {/* Colonne Actions (Filtre + Recherche) */}
          <div className="col-md-7">
            <div className="actions-toolbar">
              <div className="action-item flex-grow">
                <SelectForm onSelectChange={(formId: string | null) => setSelectedForm(formId)} />
              </div>
              <div className="action-item flex-grow">
                <input
                  type="text"
                  onChange={e => handleSearchInputChange(e)}
                  placeholder={t('common.search')}
                  className="button-search input-shadow"
                />
              </div>
            </div>
          </div>
        </div>

        {/* 3. Contenu Tableau */}
        <div className="min-height-content-folder">
          <div className={getListClassNames()}>
            <PreSignatureValidationFoldersComponent
              term={term}
              formId={selectedForm}
              viewMode={viewMode}
            />
          </div>
        </div>
      </main>
      <FooterComponent />
    </div>
  );}

export default PreSignatureValidationFolder;
